import React from "react";
import CollapsibleCardHeader from "../../../../components/atoms/cardHeader/collapsibleCardHeader";
import htmlToFormattedText from "html-to-formatted-text";

const About = ({ aboutItem }) => {
  return (
    <>
      <div className="card">
        <CollapsibleCardHeader name="About" target="collapseTwo" />
        <div
          id="collapseTwo"
          className="collapse"
          data-parent="#vender_product_preview"
        >
          <div className="card-body">
            <div className="about_p mb-7">
              <h6 className="font-weight-boldest mb-2">About this Item :</h6>
              <p className="font-size-base font-weight-bold letter-spacing text-dark-75 m-0">
                {htmlToFormattedText(aboutItem?.aboutItem?.en)}
              </p>
            </div>
            <div className="about_p">
              <h6 className="font-weight-boldest mb-2">
                Apni Kheti Product Review :
              </h6>
              <p className="font-size-base font-weight-bold letter-spacing text-dark-75 m-0">
                {htmlToFormattedText(
                  aboutItem?.apniKhetiProductReview?.text?.en
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
